import { useQuery } from '@tanstack/react-query';
import { projectService } from '../../services/project.service';
import { queryKeys } from '../../lib/query-keys';

export function useProjects(orgId: string | null, filters: Record<string, any> = {}) {
  return useQuery({
    queryKey: queryKeys.projects.all(orgId ?? ''),
    queryFn: () => projectService.getProjects(1, 100, { organization_id: orgId!, ...filters }),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res) => {
      const raw = (res as any).data;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}

export function useProject(orgId: string | null, projectId: string | null) {
  return useQuery({
    queryKey: queryKeys.projects.detail(orgId ?? '', projectId ?? ''),
    queryFn: () => projectService.getProject(projectId!),
    enabled: !!orgId && !!projectId,
    staleTime: 30_000,
    select: (res) => (res as any).data ?? res,
  });
}
